<template>
  <el-dialog
      title="Thông tin cấu hình nhà trường"
      :visible.sync="dialogVisible"
      width="1300px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      top="2vh"
  >
    <div
        v-if="systemConfigSchoolData != null"
        class="wrapper-table-outer"
    >
      <!-- Search Filter Input -->
      <div style="margin-bottom: 12px; display: flex; align-items: center; justify-content: flex-end; padding-right: 20px;">
        <span style="font-size: 14px; font-weight: bold; margin-right: 8px; color: #475569;">Tìm kiếm cấu hình:</span>
        <el-input
          v-model="searchQuery"
          placeholder="Nhập nội dung thiết lập cần tìm..."
          size="small"
          clearable
          style="width: 320px;"
          prefix-icon="el-icon-search"
        />
      </div>

      <div class="wrapper-table">
        <table border class="table-data">
        <thead>
        <tr>
          <td style="width: 30px">STT</td>
          <td style="width: 1000px">Nội dung thiết lập</td>
          <td class="table-action" style="width: 300px">Thiết lập</td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="table-index">1</td>
          <td>Có cần duyệt Album ảnh hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.album"
            >
              <el-radio :label="false">Có</el-radio>
              <el-radio :label="true">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">2</td>
          <td>Có cần duyệt đánh giá nhận xét hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.evaluate
                "
            >
              <el-radio :label="false">Có</el-radio>
              <el-radio :label="true">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">3</td>
          <td>Có cho phép sửa đánh giá khi đã duyệt hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.editAproved
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">4</td>
          <td>Có hiển thị chức năng đánh giá ngày hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.evaluateDate
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">5</td>
          <td>Có hiển thị chức năng đánh giá tuần hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.evaluateWeek
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">6</td>
          <td>Có hiển thị chức năng đánh giá tháng hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.evaluateMonth
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">7</td>
          <td>Có hiển thị chức năng đánh giá định kỳ hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse
                    .evaluatePeriod
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">8</td>
          <td>Có gửi thông báo điểm danh đến hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse
                    .approvedAttendanceArrive
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">9</td>
          <td>Giới hạn thời gian gửi điểm danh đến trước mấy giờ?</td>
          <td class="table-action">
            <el-time-picker
                class="input-data"
                style="float: left; width: 300px"
                size="mini"
                :clearable="false"
                type="time"
                value-format="HH:mm"
                format="HH:mm"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.timeAttendanceArrive
                "
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                placeholder="Chọn"
            ></el-time-picker>
          </td>
        </tr>

        <tr>
          <td class="table-index">10</td>
          <td>Có gửi thông báo điểm danh về hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse
                    .approvedAttendanceLeave
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">11</td>
          <td>Giới hạn thời gian gửi điểm danh về trước mấy giờ?</td>
          <td class="table-action">
            <el-time-picker
                class="input-data"
                style="float: left; width: 300px"
                size="mini"
                :clearable="false"
                type="time"
                value-format="HH:mm"
                format="HH:mm"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.timeAttendanceLeave
                "
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                placeholder="Chọn"
            ></el-time-picker>
          </td>
        </tr>

        <tr>
          <td class="table-index">12</td>
          <td>Cho phép giáo viên điểm danh lại với học sinh mấy ngày trước?
          </td>
          <td class="table-action">
            <el-input
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.againAttendance
                "
                placeholder="Nhập số ngày"
            ></el-input>
            <el-time-picker
                class="input-data"
                style="float: left; width: 300px; margin-top: 20px"
                size="mini"
                :clearable="false"
                type="time"
                value-format="HH:mm"
                format="HH:mm"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.timeAttendanceLimit
                "
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                placeholder="Chọn"
            ></el-time-picker>
          </td>
        </tr>

        <tr>
          <td class="table-index">13</td>
          <td>
            Gửi đơn xin nghỉ phải trước ngày đầu tiên muốn nghỉ số ngày là?
          </td>
          <td class="table-action">
            <el-input
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.dateAbsent
                "
                placeholder="Nhập số ngày"
            ></el-input>
          </td>
        </tr>

        <tr>
          <td class="table-index">14</td>
          <td>Thời gian xin nghỉ phải trước mấy giờ?</td>
          <td class="table-action">
            <el-time-picker
                class="input-data"
                style="float: left; width: 300px"
                size="mini"
                :clearable="false"
                type="time"
                value-format="HH:mm"
                format="HH:mm"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.timeAbsent
                "
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                placeholder="Chọn"
            ></el-time-picker>
          </td>
        </tr>

        <tr>
          <td class="table-index">15</td>
          <td>Mặc định có học sáng thứ 7 hàng tuần không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse
                    .morningSaturday
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">16</td>
          <td>Mặc định có học chiều thứ 7 hàng tuần không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse
                    .afternoonSaturday
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">17</td>
          <td>Mặc định có học tối thứ 7 hàng tuần không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse
                    .eveningSaturday
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">18</td>
          <td>Mặc định có học chủ nhật hàng tuần không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.sunday
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">19</td>
          <td>Hiển thị điểm danh đi học buổi sáng không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.morningAttendanceArrive
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">20</td>
          <td>Hiển thị điểm danh đi học buổi chiều không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.afternoonAttendanceArrive
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">21</td>
          <td>Hiển thị điểm danh đi học buổi tối không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.eveningAttendanceArrive
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">22</td>
          <td>Hiển thị điểm danh ăn bữa sáng không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.morningEat
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">23</td>
          <td>Hiển thị điểm danh ăn bữa phụ sáng không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.secondMorningEat
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">24</td>
          <td>Hiển thị điểm danh ăn bữa trưa không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.lunchEat
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">25</td>
          <td>Hiển thị điểm danh ăn bữa chiều không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.afternoonEat
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">26</td>
          <td>Hiển thị điểm danh ăn bữa phụ chiều không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.secondAfternoonEat
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">27</td>
          <td>Hiển thị điểm danh ăn bữa tối không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.eveningEat
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">28</td>
          <td>Có cần duyệt các thông báo gửi đi hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.appSendApproved
                "
            >
              <el-radio :label="false">Có</el-radio>
              <el-radio :label="true">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">29</td>
          <td>Có cần duyệt nội dung thời khóa biểu hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.approvedSchedule
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">30</td>
          <td>Có cần duyệt nội dung thực đơn hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.approvedMenu
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">31</td>
          <td>
            Cho phép hiển thị số điện thoại của Phụ huynh với App Giáo viên?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.parentPhone
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">32</td>
          <td>
            Cho phép Giáo viên xem thông tin chi tiết của Phụ huynh hay không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.parentInfo
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">33</td>
          <td>
            Cho phép hiển thị số điện thoại của Giáo viên với App Phụ huynh?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.employeePhone
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">34</td>
          <td>
            Cho phép Phụ huynh xem thông tin chi tiết của Giáo viên không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.employeeInfo
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">35</td>
          <td>
            Cho phép Phụ huynh xem lại lịch sử học của con khi đã chuyển
            trường hay không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.historyViewParent
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">36</td>
          <td>
            Cho phép Nhân viên xem lại lịch sử làm việc khi đã nghỉ làm ở
            trường hày không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.historyViewTeacher
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">37</td>
          <td>
            Giáo viên có được xem chi tiết các khoản thu của học sinh lớp mình
            hay không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.feesInfo
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">38</td>
          <td>
            Giáo viên có được xem số tiền học phí của học sinh hay không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.feesNumber
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">39</td>
          <td>Thiết lập giờ đến quy định của Nhà trường với học sinh?</td>
          <td class="table-action">
            <el-time-picker
                class="input-data"
                style="float: left; width: 300px"
                size="mini"
                :clearable="false"
                type="time"
                value-format="HH:mm"
                format="HH:mm"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.timeArriveKid
                "
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                placeholder="Chọn"
            ></el-time-picker>
          </td>
        </tr>

        <tr>
          <td class="table-index">40</td>
          <td>Thiết lập giờ về quy định của Nhà trường với học sinh?</td>
          <td class="table-action">
            <el-time-picker
                class="input-data"
                style="float: left; width: 300px"
                size="mini"
                :clearable="false"
                type="time"
                value-format="HH:mm"
                format="HH:mm"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.timePickupKid
                "
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                placeholder="Chọn"
            ></el-time-picker>
          </td>
        </tr>

        <tr>
          <td class="table-index">41</td>
          <td>Hiển thị thêm mẫu nhận xét của hệ thống?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.showEvaluateSys
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">42</td>
          <td>Hiển thị thêm mẫu báo đến, báo về của hệ thống?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.showAttentendanceSys
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">43</td>
          <td>Hiển thị thêm mẫu lời chúc của hệ thống?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.showWishSys
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">44</td>
          <td>Thiết lập giờ đi làm buổi sáng của Nhân viên Nhà trường?</td>
          <td class="table-action">
            <el-time-picker
                class="input-data"
                style="float: left; width: 300px"
                size="mini"
                :clearable="false"
                type="time"
                value-format="HH:mm"
                format="HH:mm"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.timeArriveEmployee
                "
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                placeholder="Chọn"
            ></el-time-picker>
          </td>
        </tr>

        <tr>
          <td class="table-index">45</td>
          <td>Thiết lập giờ về của Nhân viên Nhà trường?</td>
          <td class="table-action">
            <el-time-picker
                class="input-data"
                style="float: left; width: 300px"
                size="mini"
                :clearable="false"
                type="time"
                value-format="HH:mm"
                format="HH:mm"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.timeLeaveEmployee
                "
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                placeholder="Chọn"
            ></el-time-picker>
          </td>
        </tr>

        <tr>
          <td class="table-index">46</td>
          <td>Có tự động duyệt các phiếu thu không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.receiptNote
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">47</td>
          <td>Có tự động duyệt các phiếu chi không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.paymentNote
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">48</td>
          <td>
            Có sinh tự động hóa đơn công lương của Nhân viên cho tháng tiếp
            theo không (sinh tự động vào ngày đầu tháng)?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoBillSalaryEmployee
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">49</td>
          <td>
            Có sinh tự động các khoản công lương cho Nhân viên theo các khoản
            mặc định?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoSignSalaryEmployee
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">50</td>
          <td>
            Thiết lập ngày của tháng sẽ sinh tự động các khoản công lương cho
            Nhân sự?
          </td>
          <td class="table-action">
            <el-input-number
                :disabled="
                  !systemConfigSchoolData.schoolConfigInSysResponse
                    .autoSignSalaryEmployee
                "
                :min="1"
                :max="31"
                size="mini"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoNextmonthSalaryDate
                "
            ></el-input-number>
          </td>
        </tr>

        <tr>
          <td class="table-index">51</td>
          <td>Có tự động duyệt các khoản lương hàng tháng không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoApprovedSalary
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">52</td>
          <td>Có tự động khóa các khoản lương khi đã thanh toán đủ không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoLockSalarySuccess
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">53</td>
          <td>
            Có tự động hiển thị hóa đơn lương của cả tháng khi hóa đơn đã được
            sinh ra không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoShowBillOfMonth
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">54</td>
          <td>
            Có sinh tự động hóa đơn học phí của học sinh cho tháng tiếp theo
            không (sinh tự động vào ngày đầu tháng)?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoFeesApprovedKids
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">55</td>
          <td>
            Có sinh tự động các khoản thu với học sinh theo các khoản thu đã
            đăng ký?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoGenerateFeesKids
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">56</td>
          <td>
            Thiết lập ngày của tháng sẽ sinh tự động các khoản thu cho học
            sinh?
          </td>
          <td class="table-action">
            <el-input-number
                :disabled="
                  !systemConfigSchoolData.schoolConfigInSysResponse
                    .autoGenerateFeesKids
                "
                :min="1"
                :max="31"
                size="mini"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoNexMonthFeesDate
                "
            ></el-input-number>
          </td>
        </tr>

        <tr>
          <td class="table-index">57</td>
          <td>
            Có tự động duyệt các khoản thu của học sinh hàng tháng không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoApprovedFeesMonthKids
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">58</td>
          <td>
            Có tự động khóa các khoản thu khi Phụ huynh đã thanh toán đủ
            không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoLockFeesSuccessKids
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">59</td>
          <td>
            Có tự động hiển thị hóa đơn học phí của cả tháng khi hóa đơn đã
            được sinh ra không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoShowFeesMonth
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">60</td>
          <td>
            Có hiển thị thông tin các khoản thu dự kiến cho Phụ huynh học sinh
            không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoShowFeesFutureKids
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">61</td>
          <td>Có cho phép Phụ huynh truy cập ví hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.showWalletParent
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">62</td>
          <td>
            Có hiển thị thông tin khoản thu dự kiến của học sinh cho Giáo viên
            không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.autoShowFeesFutureKidsForTeacher
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">63</td>
          <td>Hiển thị nút xóa Nhân sự, học sinh hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.deleteStatus
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">64</td>
          <td>Mã xử lý trùng tài khoản</td>
          <td class="table-action">
            <el-input
                size="mini"
                :maxlength="6"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.verifyCode
                "
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td class="table-index">65</td>
          <td>
            Có cho phép ra trường, nghỉ học khi chưa hoàn thành học phí không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.checkCompleteFeesStatus
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">66</td>
          <td>Có gửi thông báo khi Nhà trường rút tiền từ ví không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.notifyWalletOutStatus
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">67</td>
          <td>Hiện OneCam Plus trong danh sách Camera Nhà trường?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.showOnecamPlus
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">68</td>
          <td>Số lượng ảnh tối đa khi đăng Album?</td>
          <td class="table-action">
            <el-input
                size="mini"
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse
                    .albumMaxNumber
                "
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td class="table-index">70</td>
          <td>Áp dụng tự động điền điểm danh ăn sáng theo đi học?</td>
          <td class="table-action">
            <el-radio-group v-model="systemConfigSchoolData.schoolConfigInSysResponse.breakfastAuto">
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">71</td>
          <td>Áp dụng tự động điền điểm danh ăn phụ sáng theo đi học?</td>
          <td class="table-action">
            <el-radio-group v-model="systemConfigSchoolData.schoolConfigInSysResponse.secondBreakfastAuto">
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">72</td>
          <td>Áp dụng tự động điền điểm danh ăn trưa theo đi học?</td>
          <td class="table-action">
            <el-radio-group v-model="systemConfigSchoolData.schoolConfigInSysResponse.lunchAuto">
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">73</td>
          <td>Áp dụng tự động điền điểm danh ăn chiều theo đi học?</td>
          <td class="table-action">
            <el-radio-group v-model="systemConfigSchoolData.schoolConfigInSysResponse.afternoonAuto">
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">74</td>
          <td>Áp dụng tự động điền điểm danh ăn phụ chiều theo đi học?</td>
          <td class="table-action">
            <el-radio-group v-model="systemConfigSchoolData.schoolConfigInSysResponse.secondAfternoonAuto">
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">75</td>
          <td>Áp dụng tự động điền điểm danh ăn tối theo đi học?</td>
          <td class="table-action">
            <el-radio-group v-model="systemConfigSchoolData.schoolConfigInSysResponse.dinnerAuto">
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">76</td>
          <td>Có tự động tạo điểm danh khi học sinh xin nghỉ học quá thời hạn quy định hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.attendanceCreateLetter"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">77</td>
          <td>Chọn trạng thái điểm danh mặc định khi xin nghỉ quá thời hạn?</td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.absentYesNoLetter"
            >
              <el-radio :label="true">Có phép</el-radio>
              <el-radio :label="false">Không phép</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <!-- ben co dinh -->
        <tr>
          <td class="table-index disable-row">78</td>
          <td class="disable-row">Thời gian gửi lời chúc mừng mặc định?</td>
          <td class="table-action">
            <el-time-picker
                class="input-data"
                style="float: left; width: 300px"
                size="mini"
                :clearable="false"
                type="time"
                value-format="HH:mm"
                format="HH:mm"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.timeSendCelebrate
                "
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                placeholder="Chọn"
            ></el-time-picker>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">79</td>
          <td>Chất lượng ảnh theo %?</td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.qualityPicture
                "
                placeholder="Nhập khoảng"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">80</td>
          <td>Chất lượng ảnh theo kích thước?</td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="systemConfigSchoolData.sysConfigResponse.widthPicture"
                placeholder="Nhập khoảng"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">81</td>
          <td>Chèn tiêu đề vào nội dung tin nhắn?</td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="systemConfigSchoolData.sysConfigResponse.showTitleSms"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">82</td>
          <td>Nội dung tiêu đề mặc định trong tin nhắn SMS?</td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.titleContentSms
                "
                placeholder="Nhập tiêu đề"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">83</td>
          <td>
            Hiện Phụ huynh đã đọc hay chưa đọc với App Giáo viên và Plus
            (Thông báo, nhận xét)?
          </td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="systemConfigSchoolData.sysConfigResponse.appSendParent"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">84</td>
          <td>
            Hiện Giáo viên và Nhà trường đã đọc hay chưa đọc với App Phụ huynh
            (Lời nhắn, dặn thuốc, xin nghỉ, góp ý)?
          </td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.sysConfigResponse.appSendTeacher
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">85</td>
          <td>Số lần nhắc lại khi có nội dung mới với App Phụ huynh?</td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.numberRemindParent
                "
                placeholder="Nhập số lần"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">86</td>
          <td>Khoảng thời gian nhắc giữa 2 lần của App Phụ huynh (phút)?</td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.jumpTimeParent
                "
                placeholder="Nhập số phút"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">87</td>
          <td>Số lần nhắc lại khi có nội dung mới với App Giáo viên?</td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.numberRemindTeacher
                "
                placeholder="Nhập số lần"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">88</td>
          <td>Khoảng thời gian nhắc giữa 2 lần của App Giáo viên (phút)?</td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.jumpTimeTeacher
                "
                placeholder="Nhập số phút"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">89</td>
          <td>Số lần nhắc lại khi có nội dung mới với App Plus?</td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.numberRemindPlus
                "
                placeholder="Nhập số lần"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">90</td>
          <td>Khoảng thời gian nhắc giữa 2 lần của App Plus (phút)?</td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="systemConfigSchoolData.sysConfigResponse.jumpTimePlus"
                placeholder="Nhập số phút"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">91</td>
          <td>
            Thời gian bắt đầu nhắc lần đầu có thông tin mới (mặc định là 8h30)?
          </td>
          <td class="table-action" style="background: white">
            <el-time-picker
                style="float: left; width: 300px"
                class="input-data"
                size="mini"
                :clearable="false"
                type="time"
                value-format="HH:mm"
                format="HH:mm"
                v-model="systemConfigSchoolData.sysConfigResponse.timeFrom"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                placeholder="Chọn"
            ></el-time-picker>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">92</td>
          <td>Thời gian cuối cùng có thể nhắc lần đầu (mặc định là 8h30)?</td>
          <td class="table-action" style="background: white">
            <el-time-picker
                class="input-data"
                style="float: left; width: 300px"
                size="mini"
                :clearable="false"
                type="time"
                value-format="HH:mm"
                format="HH:mm"
                v-model="systemConfigSchoolData.sysConfigResponse.timeTo"
                :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59',
                }"
                placeholder="Chọn"
            ></el-time-picker>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">93</td>
          <td>
            Số ngày quy định sau khi học sinh sang trường mới học sẽ báo Nhà
            trường, nếu học sinh còn ở trạng thái đi học?
          </td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.numberOutSchool
                "
                placeholder="Nhập số phút"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">94</td>
          <td>
            Số lần sẽ gửi thông báo cho Nhà trường với trường hợp sang trường
            mới học mà chưa nghỉ học tại trường?
          </td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="systemConfigSchoolData.sysConfigResponse.numberNotify"
                placeholder="Nhập số phút"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">95</td>
          <td>
            Khoảng thời gian gửi thông báo cho nhà trường khi học sinh học
            trường mới (đơn vị là ngày/1 lần)?
          </td>
          <td class="table-action" style="background: white">
            <el-input
                class="input-data"
                size="mini"
                v-model="systemConfigSchoolData.sysConfigResponse.jumpNumberOut"
                placeholder="Nhập số phút"
            ></el-input>
          </td>
        </tr>

        <tr class="disable-row">
          <td class="table-index">96</td>
          <td>Có tự động xóa tài khoản khi không còn đối tượng con không?</td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.sysConfigResponse.deleteAccountStatus
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr class="disable-row">
          <td class="table-index">97</td>
          <td>Thời gian xóa tự động tài khoản là sau mấy ngày?</td>
          <td class="table-action" style="background: white">
            <el-input-number
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.deleteAccountDate
                "
                placeholder="Nhập số ngày"
            ></el-input-number>
          </td>
        </tr>
        <tr class="disable-row">
          <td class="table-index">98</td>
          <td>Số thẻ nhận diện AI tối đa được thêm?</td>
          <td class="table-action" style="background: white">
            <el-input-number
                :min="3"
                :max="50"
                class="input-data"
                size="mini"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.cardNumber
                "
                placeholder="Nhập số ngày"
            ></el-input-number>
          </td>
        </tr>
        <tr class="disable-row">
          <td class="table-index">99</td>
          <td>Số vân tay nhận diện AI tối đa được thêm?</td>
          <td class="table-action" style="background: white">
            <el-input-number
                class="input-data"
                size="mini"
                :min="3"
                :max="10"
                v-model="
                  systemConfigSchoolData.sysConfigResponse.fingerNumber
                "
                placeholder="Nhập số ngày"
            ></el-input-number>
          </td>
        </tr>
        <tr class="disable-row">
          <td class="table-index">100</td>
          <td>Gửi thông tin nhận diện Onekids Smile của học sinh qua firebase cho app Plus?</td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.sysConfigResponse.sendFireBaseToPlus
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr class="disable-row">
          <td class="table-index">101</td>
          <td>Gửi thông tin nhận diện Onekids Smile của giáo viên qua firebase cho app Plus?</td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.sysConfigResponse.sendFireBaseToPlusByTeacher
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr class="disable-row">
          <td class="table-index">102</td>
          <td>Gửi thông tin nhận diện Onekids Smile của học sinh qua firebase cho app Teacher?</td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.sysConfigResponse.sendFireBaseToTeacher
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr class="disable-row">
          <td class="table-index">103</td>
          <td>Quản lý nhận diện mobile</td>
          <td class="table-action" style="background: white; padding: 10px;">
            <div
                v-for="(item, index) in [
        { label: 'Thêm khuôn mặt học sinh', model: 'addFaceStudent' },
        { label: 'Thêm khuôn mặt nhân viên', model: 'addFaceEmployee' },
        { label: 'Thêm thẻ cho học sinh', model: 'addCardStudent' },
        { label: 'Thêm thẻ cho nhân viên', model: 'addCardEmployee' },
        { label: 'Thêm vân tay cho học sinh', model: 'addFingerStudent' },
        { label: 'Thêm vân tay cho nhân viên', model: 'addFingerEmployee' },
        { label: 'Xóa thẻ cho học sinh', model: 'deleteCardStudent' },
        { label: 'Xóa thẻ cho nhân viên', model: 'deleteCardEmployee' }
      ]"
                :key="index"
                style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px;"
            >
              <span>{{ item.label }}</span>
              <el-switch
                  v-model="systemConfigSchoolData.sysConfigResponse[item.model]"
              />
            </div>
          </td>
        </tr>
        <tr class="disable-row">
          <td class="table-index">104</td>
          <td>Hiển thị nhận diện Onekids Face trên Moblie?</td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.sysConfigResponse.showOnekidsFace
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr class="disable-row">
          <td class="table-index">105</td>
          <td>Cho phép thanh toán trực tuyến?</td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.sysConfigResponse.enableOnlinePayment
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td class="table-index">106</td>
          <td>Thiết lập thời gian đón muộn</td>
          <td class="table-action">
            <table class="center-table">
              <tr>
                <td>
                  <el-radio-group
                      v-model="systemConfigSchoolData.schoolConfigInSysResponse.statusBlock"
                  >
                    <el-radio :label="true">Block</el-radio>
                    <el-radio :label="false">Ngày</el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td>
                  <span style="margin-bottom: 10px">Nhập số phút</span>
                  <el-input-number
                      v-model="systemConfigSchoolData.schoolConfigInSysResponse.blockLeaveKid"
                      style="width: 200px"
                      :min="0"
                      :step="1"
                      placeholder="Nhập số phút">
                    >
                  </el-input-number>
                </td>
              </tr>
              <tr>
                <td>
                  <el-radio-group v-model="systemConfigSchoolData.schoolConfigInSysResponse.statusUpDown">
                    <el-radio :label="true">Làm tròn lên</el-radio>
                    <el-radio :label="false">Làm tròn xuống</el-radio>
                  </el-radio-group>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td class="table-index">107</td>
          <td>Cấu hình thứ tự hiển thị tin tức màn Home trên App?</td>
          <td>
            <div class="sttShowTabHomeTable">
              <table>
                <tr>
                  <td style="text-align: center">Tin tức</td>
                  <td style="text-align: center">Facebook</td>
                  <td style="text-align: center">Video</td>
                  <td style="text-align: center">Website trường</td>
                  <td style="text-align: center">Tiktok</td>
                  <td style="text-align: center">Onekids Page</td>
                </tr>
                <tr>
                  <td style="text-align: center">
                    <el-checkbox
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.activeShowNews"
                        :disabled="true"
                    ></el-checkbox>
                  </td>
                  <td style="text-align: center">
                    <el-checkbox
                        @change="changeShowFacebook"
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.activeShowFacebook"
                    ></el-checkbox>
                  </td>
                  <td style="text-align: center">
                    <el-checkbox
                        @change="changeShowVideo"
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.activeShowVideo"
                    ></el-checkbox>
                  </td>
                  <td style="text-align: center">
                    <el-checkbox
                        @change="changeShowWebsiteSchool"
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.activeShowWebsiteSchool"
                    ></el-checkbox>
                  </td>
                  <td style="text-align: center">
                    <el-checkbox
                        @change="changeShowTiktok"
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.activeShowTiktok"
                    ></el-checkbox>
                  </td>
                  <td style="text-align: center">
                    <el-checkbox
                        @change="changeShowOneKidsPage"
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.activeShowOneKidsPage"
                    ></el-checkbox>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-select
                        class="input-common"
                        @change="changeNumberShowNews"
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews"
                        placeholder="Chọn thứ tự hiển thị tin tức"
                    >
                      <el-option
                          v-for="item in numberSelect"
                          :key="item"
                          :disabled="item === systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews"
                          :value="item"
                          :label="`${item}`"
                      ></el-option>
                    </el-select>
                  </td>


                  <td>
                    <el-select
                        class="input-common"
                        @change="changeNumberShowFacebook"
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook"
                        placeholder="Chọn thứ tự hiển thị Facebook"
                        :disabled="!systemConfigSchoolData.schoolConfigInSysResponse.activeShowFacebook"
                    >
                      <el-option
                          v-for="item in numberSelect"
                          :key="item"
                          :disabled="item === systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook"
                          :value="item"
                          :label="`${item}`"
                      ></el-option>
                    </el-select>
                  </td>

                  <td>
                    <el-select
                        class="input-common"
                        @change="changeNumberShowVideo"
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo"
                        placeholder="Chọn thứ tự hiển thị Video"
                        :disabled="!systemConfigSchoolData.schoolConfigInSysResponse.activeShowVideo"
                    >
                      <el-option
                          v-for="item in numberSelect"
                          :key="item"
                          :disabled="item === systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo"
                          :value="item"
                          :label="`${item}`"
                      ></el-option>
                    </el-select>
                  </td>

                  <td>
                    <el-select
                        class="input-common"
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool"
                        @change="changeNumberShowWebsiteSchool"
                        placeholder="Chọn thứ tự hiển thị trang web của trường"
                        :disabled="!systemConfigSchoolData.schoolConfigInSysResponse.activeShowWebsiteSchool"
                    >
                      <el-option
                          v-for="item in numberSelect"
                          :key="item"
                          :disabled="item === systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool"
                          :value="item"
                          :label="`${item}`"
                      ></el-option>
                    </el-select>
                  </td>

                  <td>
                    <el-select
                        class="input-common"
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok"
                        @change="changeNumberShowTiktok"
                        placeholder="Chọn thứ tự hiển thị Tiktok"
                        :disabled="!systemConfigSchoolData.schoolConfigInSysResponse.activeShowTiktok"
                    >
                      <el-option
                          v-for="item in numberSelect"
                          :key="item"
                          :disabled="item === systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok"
                          :value="item"
                          :label="`${item}`"
                      ></el-option>
                    </el-select>
                  </td>

                  <td>
                    <el-select
                        class="input-common"
                        @change="changeNumberShowOneKidsPage"
                        v-model="systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage"
                        placeholder="Chọn thứ tự hiển thị trang web của Onekids"
                        :disabled="!systemConfigSchoolData.schoolConfigInSysResponse.activeShowOneKidsPage"
                    >
                      <el-option
                          v-for="item in numberSelect"
                          :key="item"
                          :disabled="item === systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage"
                          :value="item"
                          :label="`${item}`"
                      ></el-option>
                    </el-select>
                  </td>
                </tr>
              </table>
            </div>

          </td>
        </tr>

        <tr>
          <td class="table-index">108</td>
          <td>Có tự động xóa dữ liệu điểm danh, nhận xét trùng hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.attendanceDuplicate"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td class="table-index">109</td>
          <td>Có áp dụng nhiều tài khoản ngân hàng cho 1 học sinh không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.statusBank"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">110</td>
          <td>
            <div>
              Thiết lập cấu hình gửi thông báo gói học phí cho nhà trường (App Plus được nhận)
            </div>
            <div>
              Với hoá đơn hết hạn đăng kí thì Plus nhận được tin nhắn thông báo theo cấu hình "Cho phép gửi lặp lại hay
              không ?"
            </div>
          </td>
          <td class="table-action">
            <table class="center-table">
              <tr>Có gửi thông báo cho hoá đơn mới không ?</tr>
              <tr>
                <td>
                  <el-radio-group
                      v-model="systemConfigSchoolData.schoolConfigInSysResponse.statusOrderNew"
                  >
                    <el-radio :label="true">Có</el-radio>
                    <el-radio :label="false">Không</el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td>
                  <el-row type="flex">
                    <el-col
                        :span="systemConfigSchoolData.schoolConfigInSysResponse.sendRepeatPlus && !systemConfigSchoolData.schoolConfigInSysResponse.statusOrderNew ? 12 : 24">
                      Ngày bắt đầu
                    </el-col>
                    <el-col :span="12"
                            v-if="systemConfigSchoolData.schoolConfigInSysResponse.sendRepeatPlus && !systemConfigSchoolData.schoolConfigInSysResponse.statusOrderNew">
                      Bước nhảy
                    </el-col>
                  </el-row>
                  <el-row type="flex">
                    <el-col
                        :span="systemConfigSchoolData.schoolConfigInSysResponse.sendRepeatPlus && !systemConfigSchoolData.schoolConfigInSysResponse.statusOrderNew ? 12 : 24">
                      <el-input-number
                          size="small"
                          v-model="systemConfigSchoolData.schoolConfigInSysResponse.dateSendPlus"
                          style="width: 110px">
                        >
                      </el-input-number>
                    </el-col>
                    <el-col :span="12"
                            v-if="systemConfigSchoolData.schoolConfigInSysResponse.sendRepeatPlus && !systemConfigSchoolData.schoolConfigInSysResponse.statusOrderNew">
                      <el-input-number
                          size="small"
                          v-model="systemConfigSchoolData.schoolConfigInSysResponse.dateJumpPlus"
                          style="width: 110px">
                        >
                      </el-input-number>
                    </el-col>
                  </el-row>
                </td>
              </tr>
              <tr v-if="!systemConfigSchoolData.schoolConfigInSysResponse.statusOrderNew">Cho phép gửi lặp lại không ?
              </tr>
              <tr v-if="!systemConfigSchoolData.schoolConfigInSysResponse.statusOrderNew">
                <td>
                  <el-radio-group
                      v-model="systemConfigSchoolData.schoolConfigInSysResponse.sendRepeatPlus"
                  >
                    <el-radio :label="true">Có</el-radio>
                    <el-radio :label="false">Không</el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Thông báo hoá đơn gói sắp hết hạn trước</span>
                  <el-input-number
                      size="small"
                      v-model="systemConfigSchoolData.schoolConfigInSysResponse.datePlus"
                      style="width: 110px">
                    >
                  </el-input-number>
                  <span style="margin-left: 20px">Ngày</span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td class="table-index">111</td>
          <td>Thiết lập cấu hình gửi thông báo gói học phí cho phụ huynh (App PHHS)</td>
          <td class="table-action">
            <table>
              <tr>
                <td>
                  <span style="margin-right: 20px">Ngày bắt đầu</span>
                  <el-input-number
                      size="small"
                      v-model="systemConfigSchoolData.schoolConfigInSysResponse.dateSendParent"
                      style="width: 110px">
                    >
                  </el-input-number>
                </td>
              </tr>
              <tr>
                <td>
                  <el-row type="flex">
                    <el-col :span="12">Bước nhảy</el-col>
                    <el-col :span="12">Tần suất</el-col>
                  </el-row>
                  <el-row type="flex">
                    <el-col :span="12">
                      <el-input-number
                          size="small"
                          v-model="systemConfigSchoolData.schoolConfigInSysResponse.dateJumpParent"
                          style="width: 110px">
                        >
                      </el-input-number>
                    </el-col>
                    <el-col :span="12">
                      <el-input-number
                          size="small"
                          v-model="systemConfigSchoolData.schoolConfigInSysResponse.dateFrequencyParent"
                          style="width: 110px">
                        >
                      </el-input-number>
                    </el-col>
                  </el-row>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Thông báo hoá đơn gói sắp hết hạn trước</span>
                  <el-input-number
                      size="small"
                      v-model="systemConfigSchoolData.schoolConfigInSysResponse.dateParent"
                      style="width: 110px">
                    >
                  </el-input-number>
                  <span style="margin-left: 20px">Ngày</span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td class="table-index">112</td>
          <td>Có tự động huỷ đăng kí gói học phí khi hết hạn hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.autoCancelTuition"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td class="table-index">113</td>
          <td>Có tự động điểm danh xin nghỉ đúng hạn hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.autoAttendanceLeaveOnTime"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td class="table-index">114</td>
          <td>Có cho điểm danh khi có đơn xin nghỉ chưa xác nhận hay không?</td>
          <td>
            <el-row type="flex">
              <el-col :span="7" style="padding-top: 10px">Plus</el-col>
              <el-col :span="17" style="padding-top: 10px">
                <el-radio-group
                    v-model="systemConfigSchoolData.schoolConfigInSysResponse.applicationForLeave"
                >
                  <el-radio :label="true">Có</el-radio>
                  <el-radio :label="false">Không</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col :span="7" style="padding-top: 10px">Teacher</el-col>
              <el-col :span="17" style="padding-top: 10px">
                <el-radio-group
                    v-model="systemConfigSchoolData.schoolConfigInSysResponse.applicationForLeaveTeacher"
                >
                  <el-radio :label="true">Có</el-radio>
                  <el-radio :label="false">Không</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </td>
        </tr>
        <tr>
          <td class="table-index">115</td>
          <td>Có tự động duyệt khi gửi điểm danh bằng mã QR không?</td>
          <td>
            <el-row type="flex">
              <el-col :span="7" style="padding-top: 10px">Teacher</el-col>
              <el-col :span="17" style="padding-top: 10px">
                <el-radio-group
                    v-model="systemConfigSchoolData.schoolConfigInSysResponse.autoApproveRollCallByQrCode"
                >
                  <el-radio :label="true">Có</el-radio>
                  <el-radio :label="false">Không</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col :span="7" style="padding-top: 10px">Parent</el-col>
              <el-col :span="17" style="padding-top: 10px">
                <el-radio-group
                    v-model="systemConfigSchoolData.schoolConfigInSysResponse.autoApproveRollCallByQrCodeKid"
                >
                  <el-radio :label="true">Có</el-radio>
                  <el-radio :label="false">Không</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </td>
        </tr>
        <tr>
          <td class="table-index">116</td>
          <td>Chọn buổi khi tự động chụp ảnh điểm danh đến bằng Onekids Face?</td>
          <td class="table-action">
            <div style="margin-top: 10px;">
              <el-checkbox
                  v-model="systemConfigSchoolData.schoolConfigInSysResponse.takePictureMorning">
                Sáng
              </el-checkbox>
              <el-checkbox
                  v-model="systemConfigSchoolData.schoolConfigInSysResponse.takePictureAfternoon">
                Chiều
              </el-checkbox>
              <el-checkbox
                  v-model="systemConfigSchoolData.schoolConfigInSysResponse.takePictureEvening">
                Tối
              </el-checkbox>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-index">117</td>
          <td>Cho phép hiển thị link tới one-cam trên onekids(Parent) hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.showOneCamOnOnekids"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td class="table-index">118</td>
          <td>Thời gian gọi lại xem album được tạo mới chưa?</td>
          <td class="table-action">
            <el-input-number
                size="small"
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.timeCallCreateAlbum"
                style="width: 110px">
              >
            </el-input-number>
            <span style="margin-left: 20px">Giây</span>
          </td>
        </tr>

        <tr>
          <td class="table-index">119</td>
          <td>Cho phép phát giọng nói khi có thông báo gửi đến hay không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.allowVoiceNotification"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>


        <tr>
          <td class="table-index">120</td>
          <td>Số lần phát giọng nói khi có thông báo?</td>
          <td class="table-action">
            <el-input-number
                size="small"
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.numberVoiceNotification"
                style="width: 110px">
              >
            </el-input-number>
            <span style="margin-left: 20px">Lần</span>
          </td>
        </tr>

        <tr>
          <td class="table-index">121</td>
          <td>Thời gian giữa 2 lần phát giọng nói khi có thông báo?</td>
          <td class="table-action">
            <el-input-number
                size="small"
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.timeBetweenTwoTimesVoice"
                style="width: 110px">
              >
            </el-input-number>
            <span style="margin-left: 20px">Giây</span>
          </td>
        </tr>

        <tr>
          <td class="table-index">122</td>
          <td>
            Hiện lựa chọn góp ý ẩn danh với App phụ huynh học sinh
          </td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.appSuggestParent"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">123</td>
          <td>
            Hiện lựa chọn góp ý ẩn danh với App giáo viên
          </td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.appSuggestTeacher"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td class="table-index">124</td>
          <td>
            Hiển thị các thiết lập khác ở màn đăng nhập
          </td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.showVersion"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td class="table-index">125</td>
          <td>
            Cho phép nhận xét ngày học sinh không cần điểm danh?
          </td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.commentsWithoutAttendance"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td class="table-index">126</td>
          <td>
            Bật âm thanh camera cho App Plus?
          </td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.openSoundAppPlus"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">127</td>
          <td>
            Hiển thị tổng tiền đã đóng và còn phải đóng (Học phí Excel)?
          </td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.showTotalMoneyTuition"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr>
          <td class="table-index">128</td>
          <td>
            Điểm danh version
          </td>
          <td class="table-action" style="background: white">
            <el-select
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.attendanceVersionConfig"
                placeholder="Chọn version"
                style="width: 250px"
            >
              <el-option
                  v-for="item in attendanceVersionConfigList"
                  :key="item.id"
                  :value="item.value"
                  :label="item.label"
              >
              </el-option>
            </el-select>
          </td>
        </tr>


        <!--        Cấu hình Timeline-->
        <tr>
          <td class="table-index">129</td>
          <td>Có cho phép lựa chọn phiên bản giao diện Trang chủ không?</td>
          <td class="table-action">
            <el-radio-group
                v-model="
                  systemConfigSchoolData.schoolConfigInSysResponse.allowSelectionInterfaceVersion
                "
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">130</td>
          <td>
            Phiên bản giao diện Trang chủ
          </td>
          <td class="table-action" style="background: white">
            <el-select
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.homepageInterfaceVersion"
                placeholder="Chọn version"
                style="width: 250px"
            >
              <el-option
                  v-for="item in homepageInterfaceVersionList"
                  :key="item.id"
                  :value="item.value"
                  :label="item.label"
              >
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td class="table-index">131</td>
          <td>
            Hiển thị cài đặt ở màn tài khoản người dùng
          </td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.showSettingAccount"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">132</td>
          <td>
            Cho phép hiển thị số điện thoại của Phụ huynh với App Phụ huynh?
          </td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.showPhoneParentToParent"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">133</td>
          <td>
            Cho phép hiển thị số điện thoại của Giáo viên với App Giáo viên?
          </td>
          <td class="table-action" style="background: white">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.showPhoneTeacherToTeacher"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">134</td>
          <td>
            Dung lượng tối đa cho một video trong album video, chat
          </td>
          <td class="table-action">
            <el-input-number
                size="small"
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.maxSizeVideo"
                style="width: 110px">
              >
            </el-input-number>
            <span style="margin-left: 20px">(MB)</span>
          </td>
        </tr>

        <tr>
          <td class="table-index">135</td>
          <td>
            Số lượng video tối đa khi tải lên cho một album video
          </td>
          <td class="table-action">
            <el-input-number
                size="small"
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.maxSizeAlbumVideo"
                style="width: 110px">
              >
            </el-input-number>
            <span style="margin-left: 20px">(video)</span>
          </td>
        </tr>

        <tr>
          <td class="table-index">136</td>
          <td>
            Số ngày lưu trữ video cho album video, chat trên server
          </td>
          <td class="table-action">
            <el-input-number
                size="small"
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.numberOfStorageDays"
                style="width: 110px">
              >
            </el-input-number>
            <span style="margin-left: 20px">(ngày)</span>
          </td>
        </tr>

        <tr>
          <td class="table-index">137</td>
          <td>
            Có cần duyệt Album(video) hay không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.approvedAlbumVideo"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">138</td>
          <td>
            Chất lượng nén video?
          </td>
          <td class="table-action">
            <el-input-number
                size="small"
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.maxQuantityAlbumVideo"
                style="width: 110px">
              >
            </el-input-number>
          </td>
        </tr>

        <tr>
          <td class="table-index">139</td>
          <td>
            Có cần duyệt tin tức giáo viên đăng hay không?
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.newsApproved"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">140</td>
          <td>
            Lập hoá đơn nháp khi thanh toán phiếu thu
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.createDaftInvoiceWhenPayment"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        <tr>
          <td class="table-index">141</td>
          <td>
            Lập hoá đơn nháp khi thanh toán trực tuyến
          </td>
          <td class="table-action">
            <el-radio-group
                v-model="systemConfigSchoolData.schoolConfigInSysResponse.allowDraftInvoice"
            >
              <el-radio :label="true">Có</el-radio>
              <el-radio :label="false">Không</el-radio>
            </el-radio-group>
          </td>
        </tr>

        </tbody>
      </table>
    </div>
    </div>
    <div v-else style="text-align: center">Không có dữ liệu</div>
    <el-tooltip
        ref="settingContentTooltip"
        effect="dark"
        placement="top"
        :manual="true"
        :value="settingTooltipVisible"
        popper-class="setting-content-tooltip-popper"
    >
      <div slot="content" v-html="settingTooltipContent"></div>
      <span ref="settingTooltipTrigger" class="setting-tooltip-trigger"></span>
    </el-tooltip>
    <span slot="footer" class="dialog-footer">
      <el-button
          type="danger"
          size="medium"
          @click="closeDialogByButton('systemConfigSchoolData')"
      >
        <i class="el-icon-circle-close"/>
        <span>Đóng</span>
      </el-button>
      <el-button
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm('systemConfigSchoolData')"
      >
        <i class="el-icon-circle-check"/>
        <span>Lưu</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import SystemConfigService from "@/services/AdminService/SystemConfigService";
import {optionSerialNumberShowNewsHomeMap} from "@/constant/listCommon";

export default {
  props: {
    dialogVisible: null,
  },
  mounted() {
    this.applySettingTooltips();
    this.bindSettingTooltipEvents();
  },
  updated() {
    this.applySettingTooltips();
  },
  beforeDestroy() {
    this.unbindSettingTooltipEvents();
  },
  watch: {
    dialogVisible(value) {
      if (value) {
        this.searchQuery = "";
        this.filterTableRows("");
        this.$nextTick(() => {
          this.applySettingTooltips();
          this.bindSettingTooltipEvents();
        });
        return;
      }
      this.hideSettingTooltip();
    },
    searchQuery(val) {
      this.filterTableRows(val);
    }
  },
  data() {
    return {
      searchQuery: "",
      systemConfigSchoolData: {
        idSchool: '',
        schoolConfigInSysResponse: {
          attendanceDuplicate: undefined,
          activeShowWebsiteSchool: undefined,
          activeShowNews: undefined,
          statusUpDown: undefined,
          blockLeaveKid: undefined,
          statusBank: undefined,
          statusBlock: undefined,
          absentYesNoLetter: undefined,
          attendanceCreateLetter: undefined,
          dinnerAuto: undefined,
          secondAfternoonAuto: undefined,
          afternoonAuto: undefined,
          lunchAuto: undefined,
          secondBreakfastAuto: undefined,
          breakfastAuto: undefined,
          showOnecamPlus: undefined,
          notifyWalletOutStatus: undefined,
          checkCompleteFeesStatus: undefined,
          autoShowFeesFutureKidsForTeacher: undefined,
          showWalletParent: undefined,
          autoShowFeesFutureKids: undefined,
          autoShowFeesMonth: undefined,
          autoLockFeesSuccessKids: undefined,
          autoApprovedFeesMonthKids: undefined,
          autoNexMonthFeesDate: undefined,
          autoGenerateFeesKids: undefined,
          approvedAttendanceLeave: undefined,
          timeAttendanceLeave: undefined,
          againAttendance: undefined,
          timeAbsent: undefined,
          morningAttendanceArrive: undefined,
          afternoonAttendanceArrive: undefined,
          eveningAttendanceArrive: undefined,
          morningEat: undefined,
          secondMorningEat: undefined,
          lunchEat: undefined,
          afternoonEat: undefined,
          secondAfternoonEat: undefined,
          eveningEat: undefined,
          appSendApproved: undefined,
          approvedSchedule: undefined,
          approvedMenu: undefined,
          parentPhone: undefined,
          parentInfo: undefined,
          employeePhone: undefined,
          employeeInfo: undefined,
          historyViewParent: undefined,
          historyViewTeacher: undefined,
          feesInfo: undefined,
          feesNumber: undefined,
          timePickupKid: undefined,
          showEvaluateSys: undefined,
          showAttentendanceSys: undefined,
          showWishSys: undefined,
          timeArriveEmployee: undefined,
          timeLeaveEmployee: undefined,
          autoBillSalaryEmployee: undefined,
          autoSignSalaryEmployee: undefined,
          autoNextmonthSalaryDate: undefined,
          autoApprovedSalary: undefined,
          autoLockSalarySuccess: undefined,
          autoShowBillOfMonth: undefined,
          autoFeesApprovedKids: undefined,
          statusOrderNew: undefined,
          dateSendPlus: undefined,
          sendRepeatPlus: undefined,
          dateJumpPlus: undefined,
          datePlus: undefined,
          dateSendParent: undefined,
          dateJumpParent: undefined,
          dateFrequencyParent: undefined,
          dateParent: undefined,
          applicationForLeave: undefined,
          applicationForLeaveTeacher: undefined,
          appSuggestParent: undefined,
          appSuggestTeacher: undefined,
          timeAttendanceLimit: undefined,
          attendanceVersionConfig: undefined,
          allowSelectionInterfaceVersion: undefined,
          homepageInterfaceVersion: undefined,
          // showSettingAccount: undefined,
          showPhoneParentToParent: undefined,
          showPhoneTeacherToTeacher: undefined,
          maxSizeVideo: undefined,
          maxSizeAlbumVideo: undefined,
          numberOfStorageDays: undefined,
          approvedAlbumVideo: undefined,
          createDaftInvoiceWhenPayment: undefined,
          allowDraftInvoice: undefined,
          maxQuantityAlbumVideo: undefined,
          newsApproved: undefined,
        },
        sysConfigResponse: {
          deleteAccountDate: undefined,
          deleteAccountStatus: undefined,
          jumpNumberOut: undefined,
          numberNotify: undefined,
          numberOutSchool: undefined,
          timeTo: undefined,
          timeFrom: undefined,
          jumpTimePlus: undefined,
          numberRemindPlus: undefined,
          jumpTimeTeacher: undefined,
          numberRemindTeacher: undefined,
          jumpTimeParent: undefined,
          numberRemindParent: undefined,
          appSendTeacher: undefined,
          appSendParent: undefined,
          titleContentSms: undefined,
          showTitleSms: undefined,
          timeSendCelebrate: undefined,
        }
      },
      optionSerialNumberShowNewsHomeMap,
      loadingButton: false,
      numberSelect: 6,
      numberOld: 0,
      sttShowNews: 0,
      sttShowFacebook: 0,
      sttShowVideo: 0,
      sttShowWebsiteSchool: 0,
      sttShowTiktok: 0,
      sttShowOneKidsPage: 0,
      settingTooltipVisible: false,
      settingTooltipContent: "",
      settingTableBodyEl: null,
      activeSettingCell: null,
      // Danh sách model key theo đúng thứ tự các row trong template
      modelKeyOrder: [
        "album", "evaluate", "editAproved", "evaluateDate", "evaluateWeek",
        "evaluateMonth", "evaluatePeriod", "approvedAttendanceArrive", "timeAttendanceArrive",
        "approvedAttendanceLeave", "timeAttendanceLeave", "againAttendance", "dateAbsent",
        "timeAbsent", "morningSaturday", "afternoonSaturday", "eveningSaturday", "sunday",
        "morningAttendanceArrive", "afternoonAttendanceArrive", "eveningAttendanceArrive",
        "morningEat", "secondMorningEat", "lunchEat", "afternoonEat", "secondAfternoonEat",
        "eveningEat", "appSendApproved", "approvedSchedule", "approvedMenu",
        "parentPhone", "parentInfo", "employeePhone", "employeeInfo",
        "historyViewParent", "historyViewTeacher", "feesInfo", "feesNumber",
        "timeArriveKid", "timePickupKid", "showEvaluateSys", "showAttentendanceSys",
        "showWishSys", "timeArriveEmployee", "timeLeaveEmployee",
        "receiptNote", "paymentNote", "autoBillSalaryEmployee", "autoSignSalaryEmployee",
        "autoNextmonthSalaryDate", "autoApprovedSalary", "autoLockSalarySuccess",
        "autoShowBillOfMonth", "autoFeesApprovedKids", "autoGenerateFeesKids",
        "autoNexMonthFeesDate", "autoApprovedFeesMonthKids", "autoLockFeesSuccessKids",
        "autoShowFeesMonth", "autoShowFeesFutureKids", "showWalletParent",
        "autoShowFeesFutureKidsForTeacher", "deleteStatus", "verifyCode",
        "checkCompleteFeesStatus", "notifyWalletOutStatus", "showOnecamPlus", "albumMaxNumber",
        "breakfastAuto", "secondBreakfastAuto", "lunchAuto", "afternoonAuto",
        "secondAfternoonAuto", "dinnerAuto", "attendanceCreateLetter", "absentYesNoLetter",
        "timeSendCelebrate", "qualityPicture", "widthPicture", "showTitleSms",
        "titleContentSms", "appSendParent", "appSendTeacher",
        "numberRemindParent", "jumpTimeParent", "numberRemindTeacher", "jumpTimeTeacher",
        "numberRemindPlus", "jumpTimePlus", "timeFrom", "timeTo",
        "numberOutSchool", "numberNotify", "jumpNumberOut",
        "deleteAccountStatus", "deleteAccountDate", "cardNumber", "fingerNumber",
        "sendFireBaseToPlus", "sendFireBaseToPlusByTeacher", "sendFireBaseToTeacher",
        "manageMobileRecognition", "showOnekidsFace", "enableOnlinePayment",
        "statusBlock", "sttShowNews", "attendanceDuplicate", "statusBank",
        "statusOrderNew", "dateSendParent", "autoCancelTuition", "autoAttendanceLeaveOnTime",
        "applicationForLeave", "autoApproveRollCallByQrCode", "takePictureMorning",
        "showOneCamOnOnekids", "timeCallCreateAlbum",
        "allowVoiceNotification", "numberVoiceNotification", "timeBetweenTwoTimesVoice",
        "appSuggestParent", "appSuggestTeacher", "showVersion",
        "commentsWithoutAttendance", "openSoundAppPlus", "showTotalMoneyTuition",
        "attendanceVersionConfig", "allowSelectionInterfaceVersion", "homepageInterfaceVersion",
        "showSettingAccount", "showPhoneParentToParent", "showPhoneTeacherToTeacher",
        "maxSizeVideo", "maxSizeAlbumVideo", "numberOfStorageDays", "approvedAlbumVideo", "createDaftInvoiceWhenPayment", "maxQuantityAlbumVideo", "newsApproved",
          "allowDraftInvoice"
      ],
      // Tùy chỉnh nội dung tooltip theo tên biến model
      settingTooltipMap: {
        "album": "Nếu chọn CÓ thì tài khoản plus phải duyệt album ảnh lên trước khi hiển thị cho GV và phụ huynh.",
        "evaluate": "Nếu chọn CÓ bật tài khoản plus phải duyệt nhận xét trước khi gửi đến phụ huynh.",
        "editAproved": "Nếu chọn CÓ thì được phép sửa đánh giá khi đã duyệt.",
        "evaluateDate": "Nếu chọn CÓ thì chức năng đánh giá ngày được hiển thị.",
        "evaluateWeek": "Nếu chọn CÓ thì chức năng đánh giá tuần được hiển thị.",
        "evaluateMonth": "Nếu chọn CÓ thì chức năng đánh giá tháng được hiển thị.",
        "evaluatePeriod": "Nếu chọn CÓ chức năng đánh giá định kỳ được hiển thị.",
        "approvedAttendanceArrive": "Nếu chọn CÓ thì hệ thống sẽ gửi thông báo khi học sinh điểm danh đến.",
        "timeAttendanceArrive": "Giới hạn thời gian để gửi điểm danh đến; sau thời gian này được xử lý là đến muộn.",
        "approvedAttendanceLeave": "Nếu chọn CÓ thì hệ thống sẽ gửi thông báo khi học sinh điểm danh về.",
        "timeAttendanceLeave": "Giới hạn thời gian để gửi điểm danh về; sau thời gian này sẽ xử lý là đón muộn/về muộn.",
        "againAttendance": "- Thời gian giáo viên được phép điểm danh lại so với ngày hiện tại.<br>- Nếu là 0 thì thêm thời gian giới hạn giáo viên được phép điểm danh trong ngày.",
        "dateAbsent": "Số ngày tối thiểu phụ huynh phải gửi đơn xin nghỉ trước ngày đầu muốn nghỉ (nhập số ngày).",
        "timeAbsent": "Thời gian  tối đa trong ngày để nộp đơn xin nghỉ; sau giờ này đơn có thể không được chấp nhận cho ngày đó hoặc được tính là nghỉ không phép.",
        "morningSaturday": "Nếu chọn CÓ thì mặc định nhà trường có học sáng thứ 7 hàng tuần.",
        "afternoonSaturday": "Nếu chọn CÓ thì mặc định nhà trường có học chiều thứ 7 hàng tuần.",
        "eveningSaturday": "Nếu chọn CÓ thì mặc định nhà trường có học tối thứ 7 hàng tuần.",
        "sunday": "Nếu chọn CÓ thì mặc định nhà trường có học Chủ nhật hàng tuần.",
        "morningAttendanceArrive": "Nếu chọn CÓ thì hiển thị chức năng điểm danh đi học buổi sáng trên ứng dụng.",
        "afternoonAttendanceArrive": "Nếu chọn CÓ thì hiển thị chức năng điểm danh đi học buổi chiều trên ứng dụng.",
        "eveningAttendanceArrive": "Nếu chọn CÓ thì hiển thị chức năng điểm danh đi học buổi tối trên ứng dụng.",
        "morningEat": "Nếu chọn CÓ thì hiển thị mục điểm danh ăn bữa sáng.",
        "secondMorningEat": "Nếu chọn CÓ thì hiển thị mục điểm danh ăn bữa phụ sáng.",
        "lunchEat": "Nếu chọn CÓ thì hiển thị mục điểm danh ăn bữa trưa.",
        "afternoonEat": "Nếu chọn CÓ thì hiển thị mục điểm danh ăn bữa chiều.",
        "secondAfternoonEat": "Nếu chọn CÓ thì hiển thị mục điểm danh ăn bữa phụ chiều.",
        "eveningEat": "Nếu chọn CÓ thì hiển thị mục điểm danh ăn bữa tối.",
        "appSendApproved": "Nếu chọn CÓ thì các thông báo gửi đi cần được duyệt trước bởi tài khoản Plus theo quy trình duyệt.",
        "approvedSchedule": "Nếu chọn CÓ thì nội dung thời khóa biểu cần được duyệt trước khi hiển thị cho giáo viên/phụ huynh.",
        "approvedMenu": "Nếu chọn CÓ thì nội dung thực đơn cần được duyệt trước khi hiển thị.",
        "parentPhone": "Nếu chọn CÓ thì số điện thoại Phụ huynh sẽ được hiển thị trên App Giáo viên.",
        "parentInfo": "Nếu chọn CÓ thì Giáo viên được phép xem thông tin chi tiết của Phụ huynh.",
        "employeePhone": "Nếu chọn CÓ thì số điện thoại Giáo viên sẽ được hiển thị trên App Phụ huynh.",
        "employeeInfo": "Nếu chọn CÓ thì Phụ huynh được xem thông tin chi tiết của Giáo viên.",
        "historyViewParent": "Nếu chọn CÓ thì Phụ huynh có thể xem lại lịch sử học của con khi đã chuyển trường.",
        "historyViewTeacher": "Nếu chọn CÓ thì Nhân viên được xem lại lịch sử làm việc khi đã nghỉ làm tại trường.",
        "feesInfo": "Nếu chọn CÓ thì Giáo viên được phép xem chi tiết các khoản thu của học sinh lớp mình.",
        "feesNumber": "Nếu chọn CÓ thì Giáo viên được xem số tiền học phí của học sinh (hiển thị số tiền).",
        "timeArriveKid": "Thiết lập giờ đến quy định của Nhà trường cho học sinh ; dùng để đánh giá sớm / muộn.",
        "timePickupKid": "Thiết lập giờ về/đón quy định của Nhà trường cho học sinh.",
        "showEvaluateSys": "Nếu chọn CÓ thì hiển thị thêm các mẫu nhận xét do hệ thống cung cấp.",
        "showAttentendanceSys": "Nếu chọn CÓ thì hiển thị thêm mẫu báo đến/báo về của hệ thống.",
        "showWishSys": "Nếu chọn CÓ thì hiển thị thêm mẫu lời chúc do hệ thống cung cấp.",
        "timeArriveEmployee": "Thiết lập giờ đến làm việc buổi sáng của Nhân viên Nhà trường.",
        "timeLeaveEmployee": "Thiết lập giờ về/kết thúc làm việc của Nhân viên Nhà trường.",
        "receiptNote": "Nếu chọn CÓ thì các phiếu thu sẽ được tự động duyệt khi tạo, không cần duyệt thủ công.",
        "paymentNote": "Nếu chọn CÓ thì các phiếu chi sẽ được tự động duyệt khi tạo, không cần duyệt thủ công.",
        "autoBillSalaryEmployee": "Nếu chọn CÓ thì sinh tự động hóa đơn công lương nhân viên cho tháng tiếp theo (sinh vào ngày đầu tháng) chỉ đối với version 1.",
        "autoSignSalaryEmployee": "Nếu chọn CÓ thì sinh tự động các khoản công lương mặc định cho nhân viên (theo cấu hình mặc định) chỉ đối với version 1.",
        "autoNextmonthSalaryDate": "Ngày của tháng dùng để sinh tự động các khoản công lương (1-31); có hiệu lực khi chức năng tự sinh bật.",
        "autoApprovedSalary": "Nếu chọn CÓ thì hệ thống tự động duyệt các khoản lương hàng tháng sau khi sinh hóa đơn.",
        "autoLockSalarySuccess": "Nếu chọn CÓ thì hệ thống tự động khóa các khoản lương khi đã thanh toán đủ (không cho sửa).",
        "autoShowBillOfMonth": "Nếu chọn CÓ thì khi hóa đơn lương tháng được sinh, hệ thống sẽ tự động hiển thị hóa đơn cả tháng.",
        "autoFeesApprovedKids": "Nếu chọn CÓ thì hệ thống tự sinh hóa đơn học phí của học sinh cho tháng tiếp theo (sinh vào ngày đầu tháng).",
        "autoGenerateFeesKids": "Nếu chọn CÓ thì hệ thống tự sinh các khoản thu cho học sinh theo các khoản đã đăng ký/mặc định (chỉ đối với version 1).",
        "autoNexMonthFeesDate": "Ngày của tháng dùng để sinh tự động các khoản thu cho học sinh (1-31); chỉ dùng khi tự sinh bật (chỉ đối với version 1).",
        "autoApprovedFeesMonthKids": "Nếu chọn CÓ thì hệ thống tự động duyệt các khoản thu hàng tháng của học sinh sau khi sinh hóa đơn (chỉ đối với version 1).",
        "autoLockFeesSuccessKids": "Nếu chọn CÓ thì hệ thống tự động khóa các khoản thu khi phụ huynh đã thanh toán đủ.",
        "autoShowFeesMonth": "Nếu chọn CÓ thì khi hóa đơn học phí tháng được sinh, hệ thống sẽ tự hiển thị hóa đơn tháng đó cho phụ huynh.",
        "autoShowFeesFutureKids": "Nếu chọn CÓ thì hiển thị cho phụ huynh thông tin các khoản thu dự kiến (ước tính) sắp tới.",
        "showWalletParent": "Nếu chọn CÓ thì cho phép Phụ huynh truy cập ví trong ứng dụng để xem/sử dụng số dư.",
        "autoShowFeesFutureKidsForTeacher": "Nếu chọn CÓ thì hiển thị thông tin khoản thu dự kiến của học sinh cho Giáo viên.",
        "deleteStatus": "Nếu chọn CÓ thì hiển thị nút xóa Nhân sự/Học sinh trong giao diện TK plus (cho phép xóa).",
        "verifyCode": "Mã xử lý trùng tài khoản (tối đa 6 ký tự) dùng khi phát hiện trùng tài khoản để phân biệt/xác thực.",
        "checkCompleteFeesStatus": "Nếu chọn CÓ thì cho phép ra trường/ nghỉ học khi chưa hoàn thành học phí (không ràng buộc thanh toán).",
        "notifyWalletOutStatus": "Nếu chọn CÓ thì gửi thông báo khi Nhà trường rút tiền từ ví (thông báo rút tiền).",
        "showOnecamPlus": "Nếu chọn CÓ thì hiển thị OneCam Plus trong danh sách Camera của Nhà trường.",
        "albumMaxNumber": "Số lượng ảnh tối đa khi đăng Album (giới hạn số ảnh mỗi album để tránh quá tải lưu trữ).",
        "breakfastAuto": "Nếu chọn CÓ thì áp dụng tự động điền điểm danh ăn sáng theo trạng thái đi học.",
        "secondBreakfastAuto": "Nếu chọn CÓ thì áp dụng tự động điền điểm danh ăn phụ sáng theo trạng thái đi học.",
        "lunchAuto": "Nếu chọn CÓ thì áp dụng tự động điền điểm danh ăn trưa theo trạng thái đi học.",
        "afternoonAuto": "Nếu chọn CÓ thì áp dụng tự động điền điểm danh ăn chiều theo trạng thái đi học.",
        "secondAfternoonAuto": "Nếu chọn CÓ thì áp dụng tự động điền điểm danh ăn phụ chiều theo trạng thái đi học.",
        "dinnerAuto": "Nếu chọn CÓ thì áp dụng tự động điền điểm danh ăn tối theo trạng thái đi học.",
        "attendanceCreateLetter": "Nếu chọn CÓ thì hệ thống tự động tạo điểm danh khi học sinh xin nghỉ quá thời hạn quy định.",
        "absentYesNoLetter": "Khi đơn xin nghỉ gửi quá thời hạn thì sẽ được điểm danh mặc định theo trạng thái được chọn Có phép/Không phép.",
        "timeSendCelebrate": "Thiết lập thời gian gửi lời chúc mừng mặc định trong ngày.",
        "qualityPicture": "Chất lượng ảnh được nén và giải nén theo %. Ví dụ 60-80 là nén 60% và giải nén lên 80% .",
        "widthPicture": "Chất lượng ảnh được nén và giải nén theo kích thước (chiều rộng pixel).",
        "showTitleSms": "Nếu chọn CÓ thì chèn tiêu đề mặc định vào nội dung tin nhắn SMS gửi đi.",
        "titleContentSms": "Nội dung tiêu đề mặc định được chèn vào tin nhắn SMS (chuỗi tiêu đề dùng cho SMS).",
        "appSendParent": "Nếu chọn CÓ thì trên App Giáo viên/Plus hiển thị trạng thái phụ huynh đã đọc/chưa đọc cho thông báo/nhận xét.",
        "appSendTeacher": "Nếu chọn CÓ thì trên App Phụ huynh hiển thị trạng thái Giáo viên/Nhà trường đã đọc/chưa đọc cho tin nhắn, xin nghỉ, dặn thuốc, góp ý.",
        "numberRemindParent": "Số lần hệ thống sẽ nhắc lại khi có nội dung mới với App Phụ huynh (số lần nhắc tối đa).",
        "jumpTimeParent": "Khoảng thời gian (phút) giữa hai lần nhắc cho App Phụ huynh (khoảng thời gian lặp lại thông báo).",
        "numberRemindTeacher": "Số lần hệ thống sẽ nhắc lại khi có nội dung mới với App Giáo viên (số lần nhắc tối đa).",
        "jumpTimeTeacher": "Khoảng thời gian (phút) giữa hai lần nhắc cho App Giáo viên (khoảng thời gian lặp lại thông báo).",
        "numberRemindPlus": "Số lần hệ thống sẽ nhắc lại khi có nội dung mới với App Plus (số lần nhắc tối đa).",
        "jumpTimePlus": "Khoảng thời gian (phút) giữa hai lần nhắc cho App Plus (khoảng thời gian lặp lại thông báo).",
        "timeFrom": "Thời gian bắt đầu trong ngày để gửi nhắc lần đầu khi có nội dung mới (mặc định ví dụ 08:30).",
        "timeTo": "Thời gian cuối cùng trong ngày có thể gửi nhắc lần đầu (mặc định ví dụ 08:30).",
        "numberOutSchool": "Số ngày quy định sau khi học sinh sang trường mới mà vẫn ở trạng thái 'đi học' sẽ báo Nhà trường.",
        "numberNotify": "Số lần hệ thống sẽ gửi thông báo cho Nhà trường khi học sinh sang trường mới mà chưa nghỉ học tại trường.",
        "jumpNumberOut": "Khoảng thời gian (ngày) giữa các lần gửi thông báo cho Nhà trường khi học sinh học trường mới (đơn vị: ngày).",
        "deleteAccountStatus": "Nếu chọn CÓ thì hệ thống tự động xóa tài khoản khi không còn đối tượng con liên kết (xóa tự động).",
        "deleteAccountDate": "Nếu bật xóa tự động tài khoản thì đây là số ngày chờ trước khi xóa tài khoản (số ngày sau khi đủ điều kiện).",
        "cardNumber": "Số thẻ nhận diện AI tối đa được thêm cho một đối tượng.",
        "fingerNumber": "Số vân tay nhận diện AI tối đa được thêm cho một đối tượng (giới hạn số vân tay).",
        "sendFireBaseToPlus": "Nếu chọn CÓ thì gửi thông tin nhận diện Onekids Smile của học sinh qua Firebase cho app Plus.",
        "sendFireBaseToPlusByTeacher": "Nếu chọn CÓ thì gửi thông tin nhận diện Onekids Smile của giáo viên qua Firebase cho app Plus.",
        "sendFireBaseToTeacher": "Nếu chọn CÓ thì gửi thông tin nhận diện Onekids Smile của học sinh qua Firebase cho app Teacher.",
        "manageMobileRecognition": "Bật/tắt các tính năng quản lý nhận diện mobile (thêm/xóa khuôn mặt, thẻ, vân tay) cho học sinh/nhân viên.",
        "showOnekidsFace": "Nếu chọn CÓ thì hiển thị tính năng nhận diện Onekids Face trên Mobile (bật tính năng nhận diện).",
        "enableOnlinePayment": "Nếu chọn CÓ thì cho phép thanh toán trực tuyến (kích hoạt chức năng thanh toán online).",
        "statusBlock": "Cấu hình thời gian đón muộn: chọn Block hoặc ngày, nhập số phút giới hạn và lựa chọn làm tròn lên/xuống.",
        "sttShowNews": "Cấu hình thứ tự hiển thị nguồn nội dung trên màn Home (Tin tức, Facebook, Video, Website, Tiktok, Onekids Page).",
        "attendanceDuplicate": "Nếu chọn CÓ thì hệ thống tự động xóa dữ liệu điểm danh/nhận xét trùng để tránh lặp dữ liệu.",
        "statusBank": "Nếu chọn CÓ thì cho phép áp dụng nhiều tài khoản ngân hàng cho một học sinh.",
        "statusOrderNew": "Cấu hình gửi thông báo gói học phí cho Nhà trường/App Plus: thiết lập gửi hóa đơn mới, gửi lặp lại, ngày bắt đầu, bước nhảy, v.v.",
        "dateSendParent": "Cấu hình gửi thông báo gói học phí cho phụ huynh (App PHHS): ngày bắt đầu, bước nhảy, tần suất và thông báo trước ngày hết hạn.",
        "autoCancelTuition": "Nếu chọn CÓ thì tự động hủy đăng ký gói học phí khi hết hạn.",
        "autoAttendanceLeaveOnTime": "Nếu chọn CÓ thì hệ thống tự động điểm danh xin nghỉ đúng hạn (theo cấu hình).",
        "applicationForLeave": "Cho phép điểm danh khi có đơn xin nghỉ chưa xác nhận (ứng dụng Plus/Teacher tuỳ từng thiết lập).",
        "autoApproveRollCallByQrCode": "Nếu chọn CÓ thì tự động duyệt khi gửi điểm danh bằng mã QR (áp dụng cho Teacher/Parent tuỳ thiết lập).",
        "takePictureMorning": "Chọn buổi tự động chụp ảnh điểm danh đến bằng Onekids Face (Sáng/Chiều/Tối).",
        "showOneCamOnOnekids": "Nếu chọn CÓ thì hiển thị link tới One-Cam trên Onekids (Parent).",
        "timeCallCreateAlbum": "Thời gian gọi lại (giây) để kiểm tra album mới được tạo; giá trị tính bằng giây.",
        "allowVoiceNotification": "Nếu chọn CÓ thì cho phép phát giọng nói khi có thông báo gửi đến.",
        "numberVoiceNotification": "Số lần phát giọng nói khi có thông báo (số lần lặp lại phát âm thanh).",
        "timeBetweenTwoTimesVoice": "Khoảng thời gian (giây) giữa hai lần phát giọng nói khi có thông báo.",
        "appSuggestParent": "Nếu chọn CÓ thì hiển thị lựa chọn góp ý ẩn danh cho App Phụ huynh.",
        "appSuggestTeacher": "Nếu chọn CÓ thì hiển thị lựa chọn góp ý ẩn danh cho App Giáo viên.",
        "showVersion": "Nếu chọn CÓ thì hiển thị các thiết lập khác ở màn đăng nhập.",
        "commentsWithoutAttendance": "Nếu chọn CÓ thì cho phép nhập nhận xét ngày mà không yêu cầu điểm danh.",
        "openSoundAppPlus": "Nếu chọn CÓ thì bật âm thanh camera cho App Plus (phát âm thanh khi có camera event).",
        "showTotalMoneyTuition": "Nếu chọn CÓ thì hiển thị tổng tiền đã đóng và còn phải đóng trong báo cáo Học phí (Excel).",
        "attendanceVersionConfig": "Chọn phiên bản điểm danh  để sử dụng trong hệ thống.",
        "allowSelectionInterfaceVersion": "Nếu chọn CÓ thì cho phép người dùng lựa chọn phiên bản giao diện Trang chủ (hiển thị nút thiết lập).",
        "homepageInterfaceVersion": "Phiên bản giao diện Trang chủ đang được chọn (ảnh hưởng cách hiển thị Home).\n" +
            "Khi chọn Version 1, hệ thống sẽ sử dụng giao diện cũ và không hỗ trợ tạo mới dữ liệu Timeline.\n" +
            "Các bài Timeline mới sau khi chuyển sang Version 1 sẽ không được hiển thị hoặc đồng bộ.\n" +
            "Khuyến nghị sử dụng Version 2 để tiếp tục sử dụng đầy đủ tính năng Timeline.",
        "showSettingAccount": "Nếu chọn CÓ thì hiển thị cài đặt ở màn tài khoản người dùng.",
        "showPhoneParentToParent": "Nếu chọn CÓ thì cho phép hiển thị số điện thoại của Phụ huynh trên App Phụ huynh.",
        "showPhoneTeacherToTeacher": "Nếu chọn CÓ thì cho phép hiển thị số điện thoại của Giáo viên trên App Giáo viên.",
        "maxSizeVideo": "Dung lượng tối đa cho một video trong album video và chat (MB); hệ thống sẽ giới hạn khi tải lên.",
        "maxSizeAlbumVideo": "Số lượng video tối đa trong một album video trong 1 lần đăng.",
        "numberOfStorageDays": "Số ngày lưu trữ video cho album video và chat trên server, hết thời hạn sẽ bị xóa khỏi server.",
        "approvedAlbumVideo": "Nếu chọn CÓ thì Plus cần duyệt Album video trước khi hiển thị cho người dùng.",
        "createDaftInvoiceWhenPayment": "Lập hoá đơn nháp Onekids (Hoá đơn điện tử) khi thanh toán phiếu thu cả thủ công và thanh toán trực tuyến",
        "maxQuantityAlbumVideo": "Chất lượng video được nén khi lưu trữ lại trên hệ thống",
        "newsApproved": "Nếu chọn CÓ thì Nhà trường cần duyệt bài viết Tin tức trước khi hiển thị cho người dùng.",
        "allowDraftInvoice": "Nếu chọn CÓ thì cho phép tạo hoá đơn nháp Onekids (Hoá đơn điện tử) khi thanh toán trực tuyến."
      },
      maxCountShow: 6,
      attendanceVersionConfigList: [
        {id: 1, value: "VERSION_1", label: "VERSION 1"},
        {id: 2, value: "VERSION_2", label: "VERSION 2"},
        {id: 3, value: "VERSION_3", label: "VERSION 3"},
        {id: 4, value: "VERSION_4", label: "VERSION 4"},
      ],

      homepageInterfaceVersionList: [
        {id: 1, value: "VERSION_1", label: "VERSION 1"},
        {id: 2, value: "VERSION_2", label: "VERSION 2"},
      ]
    };
  },
  methods: {
    filterTableRows(query) {
      this.$nextTick(() => {
        const rows = this.$el.querySelectorAll(".table-data > tbody > tr");
        if (!rows.length) return;
        const q = query ? query.toLowerCase().trim() : "";
        rows.forEach((row) => {
          const cell = row.children[1]; // cột nội dung (cột thứ 2)
          if (!cell) return;
          const descText = cell.innerText || cell.textContent;
          if (!q || descText.toLowerCase().includes(q)) {
            row.style.display = "";
          } else {
            row.style.display = "none";
          }
        });
      });
    },

    applySettingTooltips() {
      this.$nextTick(() => {
        if (!this.$el) {
          return;
        }
        // Dùng direct child selector để bỏ qua các <tr> trong nested table
        const rows = this.$el.querySelectorAll(".table-data > tbody > tr");
        rows.forEach((row, index) => {
          const cell = row.children[1]; // cột nội dung (cột thứ 2)
          if (!cell) {
            return;
          }
          const tooltipText = (cell.innerText || "").replace(/\s+/g, " ").trim();
          const modelKey = this.modelKeyOrder[index] || "";
          if (tooltipText) {
            cell.classList.add("setting-content-cell");
            cell.setAttribute("data-setting-key", modelKey);
            cell.setAttribute("data-setting-text", tooltipText);
          }
        });
      });
    },

    bindSettingTooltipEvents() {
      if (!this.$el) {
        return;
      }
      const tableBody = this.$el.querySelector(".table-data tbody");
      if (!tableBody || this.settingTableBodyEl === tableBody) {
        return;
      }
      this.unbindSettingTooltipEvents();
      this.settingTableBodyEl = tableBody;
      tableBody.addEventListener("mouseover", this.handleSettingCellMouseOver);
      tableBody.addEventListener("mouseout", this.handleSettingCellMouseOut);
    },

    unbindSettingTooltipEvents() {
      if (!this.settingTableBodyEl) {
        return;
      }
      this.settingTableBodyEl.removeEventListener("mouseover", this.handleSettingCellMouseOver);
      this.settingTableBodyEl.removeEventListener("mouseout", this.handleSettingCellMouseOut);
      this.settingTableBodyEl = null;
    },

    handleSettingCellMouseOver(event) {
      const cell = event.target && event.target.closest ? event.target.closest("td.setting-content-cell") : null;
      if (!cell || !this.settingTableBodyEl || !this.settingTableBodyEl.contains(cell)) {
        return;
      }
      if (this.activeSettingCell === cell) {
        return;
      }
      this.showSettingTooltip(cell);
    },

    handleSettingCellMouseOut(event) {
      if (!this.activeSettingCell) {
        return;
      }
      const nextCell = event.relatedTarget && event.relatedTarget.closest
          ? event.relatedTarget.closest("td.setting-content-cell")
          : null;
      if (nextCell && this.settingTableBodyEl && this.settingTableBodyEl.contains(nextCell)) {
        if (nextCell !== this.activeSettingCell) {
          this.showSettingTooltip(nextCell);
        }
        return;
      }
      this.hideSettingTooltip();
    },

    showSettingTooltip(cell) {
      const settingKey = cell.getAttribute("data-setting-key") || "";
      const defaultText = cell.getAttribute("data-setting-text") || "";
      const customText = this.settingTooltipMap[settingKey];
      this.settingTooltipContent = customText || defaultText;
      if (!this.settingTooltipContent) {
        this.hideSettingTooltip();
        return;
      }
      this.activeSettingCell = cell;
      this.positionSettingTooltipTrigger(cell);
      this.settingTooltipVisible = true;
      this.$nextTick(() => {
        if (this.$refs.settingContentTooltip && this.$refs.settingContentTooltip.updatePopper) {
          this.$refs.settingContentTooltip.updatePopper();
        }
      });
    },

    positionSettingTooltipTrigger(cell) {
      const trigger = this.$refs.settingTooltipTrigger;
      if (!trigger) {
        return;
      }
      const rect = cell.getBoundingClientRect();
      trigger.style.left = `${Math.max(rect.right - 20, 8)}px`;
      trigger.style.top = `${rect.top + rect.height / 2}px`;
    },

    hideSettingTooltip() {
      this.settingTooltipVisible = false;
      this.activeSettingCell = null;
    },

    checkActive() {
      let countActive = 0;
      const activeShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowNews;
      const activeShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowFacebook;
      const activeShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowVideo;
      const activeShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowTiktok;
      const activeShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowWebsiteSchool;
      const activeShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowOneKidsPage;

      if (activeShowNews) {
        ++countActive;
      }

      if (activeShowFacebook) {
        ++countActive;
      }

      if (activeShowVideo) {
        ++countActive;
      }

      if (activeShowTiktok) {
        ++countActive;
      }

      if (activeShowWebsiteSchool) {
        ++countActive;
      }

      if (activeShowOneKidsPage) {
        ++countActive;
      }

      return countActive;
    },

    changeShowFacebook(value) {
      const countActive = this.checkActive();
      const indexShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
      const indexShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
      const indexShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
      const indexShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
      const indexShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
      const indexShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;

      this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowFacebook = value;

      if (!value) {
        --this.numberSelect;

        if (indexShowNews > indexShowFacebook) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
          --this.sttShowNews;
        }

        if (indexShowVideo > indexShowFacebook) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
          --this.sttShowVideo;
        }

        if (indexShowWebsiteSchool > indexShowFacebook) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
          --this.sttShowWebsiteSchool;
        }

        if (indexShowTiktok > indexShowFacebook) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
          --this.sttShowTiktok;
        }

        if (indexShowOneKidsPage > indexShowFacebook) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;
          --this.sttShowOneKidsPage;
        }

        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = this.maxCountShow;
        this.sttShowFacebook = this.maxCountShow;

      } else {

        if (indexShowNews === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews = indexShowFacebook;
          this.sttShowNews = indexShowFacebook;
        }

        if (indexShowTiktok === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = indexShowFacebook;
          this.sttShowTiktok = indexShowFacebook;
        }

        if (indexShowVideo === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = indexShowFacebook;
          this.sttShowVideo = indexShowFacebook;
        }

        if (indexShowWebsiteSchool === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = indexShowFacebook;
          this.sttShowWebsiteSchool = indexShowFacebook;
        }

        if (indexShowOneKidsPage === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = indexShowFacebook;
          this.sttShowOneKidsPage = indexShowFacebook;
        }
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = countActive;
        this.sttShowFacebook = countActive;
        ++this.numberSelect;
      }
    },

    changeShowVideo(value) {
      const countActive = this.checkActive();
      const indexShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
      const indexShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
      const indexShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
      const indexShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
      const indexShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
      const indexShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;

      this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowVideo = value;

      if (!value) {
        --this.numberSelect;

        if (indexShowNews > indexShowVideo) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
          --this.sttShowNews;
        }

        if (indexShowFacebook > indexShowVideo) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
          --this.sttShowFacebook;
        }

        if (indexShowWebsiteSchool > indexShowVideo) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
          --this.sttShowWebsiteSchool;
        }

        if (indexShowTiktok > indexShowVideo) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
          --this.sttShowTiktok;
        }

        if (indexShowOneKidsPage > indexShowVideo) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;
          --this.sttShowOneKidsPage;
        }

        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = this.maxCountShow;
        this.sttShowVideo = this.maxCountShow;

      } else {

        if (indexShowNews === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews = indexShowVideo;
          this.sttShowNews = indexShowVideo;
        }

        if (indexShowTiktok === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = indexShowVideo;
          this.sttShowTiktok = indexShowVideo;
        }

        if (indexShowFacebook === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = indexShowVideo;
          this.sttShowFacebook = indexShowVideo;
        }

        if (indexShowWebsiteSchool === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = indexShowVideo;
          this.sttShowWebsiteSchool = indexShowVideo;
        }

        if (indexShowOneKidsPage === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = indexShowVideo;
          this.sttShowOneKidsPage = indexShowVideo;
        }
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = countActive;
        this.sttShowVideo = countActive;
        ++this.numberSelect;
      }
    },

    changeShowWebsiteSchool(value) {
      const countActive = this.checkActive();
      const indexShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
      const indexShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
      const indexShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
      const indexShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
      const indexShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
      const indexShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;

      this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowWebsiteSchool = value;

      if (!value) {
        --this.numberSelect;

        if (indexShowNews > indexShowWebsiteSchool) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
          --this.sttShowNews;
        }

        if (indexShowVideo > indexShowWebsiteSchool) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
          --this.sttShowVideo;
        }

        if (indexShowFacebook > indexShowWebsiteSchool) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
          --this.sttShowFacebook;
        }

        if (indexShowTiktok > indexShowWebsiteSchool) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
          --this.sttShowTiktok;
        }

        if (indexShowOneKidsPage > indexShowWebsiteSchool) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;
          --this.sttShowOneKidsPage;
        }

        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = this.maxCountShow;
        this.sttShowWebsiteSchool = this.maxCountShow;

      } else {

        if (indexShowNews === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews = indexShowWebsiteSchool;
          this.sttShowNews = indexShowWebsiteSchool;
        }

        if (indexShowTiktok === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = indexShowWebsiteSchool;
          this.sttShowTiktok = indexShowWebsiteSchool;
        }

        if (indexShowFacebook === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = indexShowWebsiteSchool;
          this.sttShowFacebook = indexShowWebsiteSchool;
        }

        if (indexShowVideo === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = indexShowWebsiteSchool;
          this.sttShowVideo = indexShowWebsiteSchool;
        }

        if (indexShowOneKidsPage === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = indexShowWebsiteSchool;
          this.sttShowOneKidsPage = indexShowWebsiteSchool;
        }
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = countActive;
        this.sttShowWebsiteSchool = countActive;
        ++this.numberSelect
      }
    },

    changeShowTiktok(value) {
      const countActive = this.checkActive();
      const indexShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
      const indexShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
      const indexShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
      const indexShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
      const indexShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
      const indexShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;

      this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowTiktok = value;

      if (!value) {
        --this.numberSelect;

        if (indexShowNews > indexShowTiktok) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
          --this.sttShowNews;
        }

        if (indexShowVideo > indexShowTiktok) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
          --this.sttShowVideo;
        }

        if (indexShowWebsiteSchool > indexShowTiktok) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
          --this.sttShowWebsiteSchool;
        }

        if (indexShowFacebook > indexShowTiktok) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
          --this.sttShowFacebook;
        }

        if (indexShowOneKidsPage > indexShowTiktok) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;
          --this.sttShowOneKidsPage;
        }

        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = this.maxCountShow;
        this.sttShowTiktok = this.maxCountShow;
      } else {

        if (indexShowNews === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews = indexShowTiktok;
          this.sttShowNews = indexShowTiktok;
        }

        if (indexShowWebsiteSchool === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = indexShowTiktok;
          this.sttShowWebsiteSchool = indexShowTiktok;
        }

        if (indexShowFacebook === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = indexShowTiktok;
          this.sttShowFacebook = indexShowTiktok;
        }

        if (indexShowVideo === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = indexShowTiktok;
          this.sttShowVideo = indexShowTiktok;
        }

        if (indexShowOneKidsPage === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = indexShowTiktok;
          this.sttShowOneKidsPage = indexShowTiktok;
        }
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = countActive;
        this.sttShowTiktok = countActive;
        ++this.numberSelect;
      }
    },

    changeShowOneKidsPage(value) {
      const countActive = this.checkActive();
      const indexShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
      const indexShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
      const indexShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
      const indexShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
      const indexShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
      const indexShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;

      this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowOneKidsPage = value;

      if (!value) {
        --this.numberSelect;

        if (indexShowNews > indexShowOneKidsPage) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
          --this.sttShowNews;
        }

        if (indexShowVideo > indexShowOneKidsPage) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
          --this.sttShowVideo;
        }

        if (indexShowWebsiteSchool > indexShowOneKidsPage) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
          --this.sttShowWebsiteSchool;
        }

        if (indexShowFacebook > indexShowOneKidsPage) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
          --this.sttShowFacebook;
        }

        if (indexShowTiktok > indexShowOneKidsPage) {
          --this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
          --this.sttShowTiktok;
        }

        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = this.maxCountShow;
        this.sttShowOneKidsPage = this.maxCountShow;

      } else {

        if (indexShowNews === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews = indexShowOneKidsPage;
          this.sttShowNews = indexShowOneKidsPage;
        }

        if (indexShowWebsiteSchool === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = indexShowOneKidsPage;
          this.sttShowWebsiteSchool = indexShowOneKidsPage;
        }

        if (indexShowFacebook === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = indexShowOneKidsPage;
          this.sttShowFacebook = indexShowOneKidsPage;
        }

        if (indexShowVideo === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = indexShowOneKidsPage;
          this.sttShowVideo = indexShowOneKidsPage;
        }

        if (indexShowTiktok === countActive) {
          this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = indexShowOneKidsPage;
          this.sttShowTiktok = indexShowOneKidsPage;
        }
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = countActive;
        this.sttShowOneKidsPage = countActive;
        ++this.numberSelect;
      }
    },

    changeNumberShowNews(value) {
      const indexShowNews = this.sttShowNews;
      const indexShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
      const indexShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
      const indexShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
      const indexShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
      const indexShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;

      if (indexShowFacebook === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = indexShowNews;
        this.sttShowFacebook = indexShowNews;
      }

      if (indexShowTiktok === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = indexShowNews;
        this.sttShowFacebook = indexShowNews;
      }

      if (indexShowVideo === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = indexShowNews;
        this.sttShowVideo = indexShowNews;
      }

      if (indexShowWebsiteSchool === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = indexShowNews;
        this.sttShowWebsiteSchool = indexShowNews;
      }

      if (indexShowOneKidsPage === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = indexShowNews;
        this.sttShowOneKidsPage = indexShowNews;
      }

      this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews = value;
      this.sttShowNews = value;
    },

    changeNumberShowFacebook(value) {
      const indexShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
      const indexShowFacebook = this.sttShowFacebook;
      const indexShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
      const indexShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
      const indexShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
      const indexShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;

      if (indexShowNews === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews = indexShowFacebook;
        this.sttShowNews = indexShowFacebook;
      }

      if (indexShowTiktok === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = indexShowFacebook;
        this.sttShowTiktok = indexShowFacebook;
      }

      if (indexShowVideo === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = indexShowFacebook;
        this.sttShowVideo = indexShowFacebook;
      }

      if (indexShowWebsiteSchool === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = indexShowFacebook;
        this.sttShowWebsiteSchool = indexShowFacebook;
      }

      if (indexShowOneKidsPage === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = indexShowFacebook;
        this.sttShowOneKidsPage = indexShowFacebook;
      }

      this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = value;
      this.sttShowFacebook = value;
    },

    changeNumberShowVideo(value) {
      const indexShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
      const indexShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
      const indexShowVideo = this.sttShowVideo;
      const indexShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
      const indexShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
      const indexShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;

      if (indexShowNews === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews = indexShowVideo;
        this.sttShowNews = indexShowVideo;
      }

      if (indexShowFacebook === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = indexShowVideo;
        this.sttShowFacebook = indexShowVideo;
      }

      if (indexShowTiktok === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = indexShowVideo;
        this.sttShowTiktok = indexShowVideo;
      }

      if (indexShowWebsiteSchool === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = indexShowVideo;
        this.sttShowWebsiteSchool = indexShowVideo;
      }

      if (indexShowOneKidsPage === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = indexShowVideo;
        this.sttShowOneKidsPage = indexShowVideo;
      }

      this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = value;
      this.sttShowVideo = value;
    },

    changeNumberShowWebsiteSchool(value) {
      const indexShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
      const indexShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
      const indexShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
      const indexShowWebsiteSchool = this.sttShowWebsiteSchool;
      const indexShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
      const indexShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;

      if (indexShowNews === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews = indexShowWebsiteSchool;
        this.sttShowNews = indexShowWebsiteSchool;
      }

      if (indexShowFacebook === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = indexShowWebsiteSchool;
        this.sttShowFacebook = indexShowWebsiteSchool;
      }

      if (indexShowVideo === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = indexShowWebsiteSchool;
        this.sttShowVideo = indexShowWebsiteSchool;
      }

      if (indexShowTiktok === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = indexShowWebsiteSchool;
        this.sttShowTiktok = indexShowWebsiteSchool;
      }

      if (indexShowOneKidsPage === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = indexShowWebsiteSchool;
        this.sttShowOneKidsPage = indexShowWebsiteSchool;
      }

      this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = value;
      this.sttShowWebsiteSchool = value;
    },

    changeNumberShowTiktok(value) {
      const indexShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
      const indexShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
      const indexShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
      const indexShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
      const indexShowTiktok = this.sttShowTiktok;
      const indexShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;

      if (indexShowNews === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews = indexShowTiktok;
        this.sttShowNews = indexShowTiktok;
      }

      if (indexShowFacebook === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = indexShowTiktok;
        this.sttShowFacebook = indexShowTiktok;
      }

      if (indexShowVideo === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = indexShowTiktok;
        this.sttShowVideo = indexShowTiktok;
      }

      if (indexShowWebsiteSchool === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = indexShowTiktok;
        this.sttShowWebsiteSchool = indexShowTiktok;
      }

      if (indexShowOneKidsPage === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = indexShowTiktok;
        this.sttShowOneKidsPage = indexShowTiktok;
      }

      this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = value;
      this.sttShowTiktok = value;
    },

    changeNumberShowOneKidsPage(value) {
      const indexShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
      const indexShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
      const indexShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
      const indexShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
      const indexShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
      const indexShowOneKidsPage = this.sttShowOneKidsPage

      if (indexShowNews === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews = indexShowOneKidsPage;
        this.sttShowNews = indexShowOneKidsPage;
      }

      if (indexShowFacebook === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook = indexShowOneKidsPage;
        this.sttShowFacebook = indexShowOneKidsPage;
      }

      if (indexShowVideo === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo = indexShowOneKidsPage;
        this.sttShowVideo = indexShowOneKidsPage;
      }

      if (indexShowWebsiteSchool === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool = indexShowOneKidsPage;
        this.sttShowWebsiteSchool = indexShowOneKidsPage;
      }

      if (indexShowTiktok === value) {
        this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok = indexShowOneKidsPage;
        this.sttShowTiktok = indexShowOneKidsPage;
      }

      this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage = value;
      this.sttShowOneKidsPage = value;
    },

    async changeNumberSelect() {
      this.numberSelect = 6
      if (this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowWebsiteSchool === false) {
        this.numberSelect--
      }
      if (this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowTiktok === false) {
        this.numberSelect--
      }
      if (this.systemConfigSchoolData.schoolConfigInSysResponse.activeShowOneKidsPage === false) {
        this.numberSelect--
      }
    },

    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.$refs["systemConfigSchoolData"].resetFields();
      }, 300);
    },
    //click when click button
    closeDialogByButton(fromData) {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.$refs[fromData].resetFields();
      }, 300);
    },
    resetFormData() {
      this.$refs["systemConfigSchoolData"].resetFields();
    },
    submitForm(fromData) {
      this.loadingButton = true;

      let sttNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews;
      let sttFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook;
      let sttVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo;
      let sttShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool;
      let sttShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok;
      let sttShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage;
      if (sttNews === sttFacebook || sttNews === sttVideo || sttNews === sttShowWebsiteSchool
          || sttNews === sttShowTiktok || sttNews === sttShowOneKidsPage
          || sttFacebook === sttVideo || sttFacebook === sttShowWebsiteSchool || sttFacebook === sttShowTiktok
          || sttFacebook === sttShowOneKidsPage
          || sttVideo === sttShowWebsiteSchool || sttVideo === sttShowTiktok || sttVideo === sttShowOneKidsPage
          || sttShowWebsiteSchool === sttShowTiktok || sttShowWebsiteSchool === sttShowOneKidsPage
          || sttShowTiktok === sttShowOneKidsPage
      ) {
        this.$message({
          message: "Không được chọn thứ tự hiển thị tin tức màn Home trên App giống nhau ",
          type: "error",
          duration: 2000
        });
        this.loadingButton = false;
      } else {
        SystemConfigService.updateSchoolConfigSystem(this.systemConfigSchoolData)
            .then((response) => {
              let data = response.data.data;
              console.log(data);
              this.$message({
                message: "Cập nhật thành công",
                type: "success",
              });

              setTimeout(() => {
                this.closeDialogByButton(fromData);
              }, 500);
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
            });
      }
    },
    getDataInitial(id) {
      SystemConfigService.findSchoolConfigSystem(id)
          .then((resp) => {
            this.systemConfigSchoolData = resp.data.data;
            this.sttShowNews = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowNews
            this.sttShowFacebook = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowFacebook
            this.sttShowVideo = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowVideo
            this.sttShowWebsiteSchool = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowWebsiteSchool
            this.sttShowTiktok = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowTiktok
            this.sttShowOneKidsPage = this.systemConfigSchoolData.schoolConfigInSysResponse.sttShowOneKidsPage
            this.changeNumberSelect()
          })
          .catch((err) => {
            console.log(err);
            this.systemConfigSchoolData = null;
          });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__title {
  font-size: 25px;
  color: #606266;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}

/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}

/deep/ .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 10px;
}

.over-table {
  width: 97%;
  margin: 0 auto;
}

.table-data {
  border-collapse: collapse;
  border: 1px solid #ebeef5;
}

@media screen and (max-width: 1366px) {
  .wrapper-table {
    height: 480px;
  }
}

@media screen and (min-width: 1367px) {
  .wrapper-table {
    height: 740px;
  }
}

.input-common {
  width: 60px;
}

@media screen and (max-width: 1366px) {
  .sttShowTabHomeTable {
    width: 300px;
  }
}

@media screen and (min-width: 1367px) {
  .sttShowTabHomeTable {
    width: 300px;
  }
}

.sttShowTabHomeTable {
  /* cho phép cuộn ngang nếu cần, nhưng không tạo cuộn dọc kép */
  overflow-y: visible;
  overflow-x: auto;
  border-bottom: 1px solid #ebeef5;
}

.wrapper-table {
  overflow-y: auto;
  border-top: 1px solid #ebeef5;
}

thead {
  background: #78a5e7;
  color: white;
  font-weight: bold;
}

tbody {
  color: #606266;
  font-size: 14px;
  font-family: Arial, Helvetica, sans-serif;
}

td {
  padding: 10px;
}

.setting-content-cell {
  position: relative;
  padding-right: 34px;
}

.setting-content-cell::after {
  content: "i";
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #3091f5;
  color: #3091f5;
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  box-sizing: border-box;
}

.setting-tooltip-trigger {
  position: fixed;
  width: 1px;
  height: 1px;
  pointer-events: none;
  opacity: 0;
}

/deep/ .setting-content-tooltip-popper {
  max-width: 520px;
  line-height: 1.5;
  white-space: normal;
}

.table-index {
  width: 30px;
  text-align: center;
}

.table-item-name {
  text-align: center;
}

.table-action {
  width: 50px;
  text-align: center;
}

.disable-row {
  background: #e4e7ed;
}
</style>
